<template>
    <div>
        &nbsp;
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "Inscription",
    mounted() {
        if (this.roles && this.roles.length) {
            if (this.roles.indexOf("admin") !== -1) {
                this.$router.push("/dashboard");
            } else {
                this.$router.push("/stock");
            }
        }
    },
    computed: {
        ...mapState({
            roles: state => state.user.roles
        })
    }
};
</script>
